import { useSyncExternalStore } from 'react';

// Inspo: https://www.epicreact.dev/use-sync-external-store-demystified-for-practical-react-development-w5ac0
export function makeMediaQueryStore(mediaQuery: string) {
  function subscribe(callback: () => void) {
    const mediaQueryList = window.matchMedia(mediaQuery);
    mediaQueryList.addEventListener('change', callback);
    return () => {
      mediaQueryList.removeEventListener('change', callback);
    };
  }
  function getSnapshot() {
    return window.matchMedia(mediaQuery).matches;
  }
  function getServerSnapshot() {
    return false;
  }

  return function useMediaQuery() {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  };
}
